import { Status, StatusType } from "@/encounters/zod-schemas/encounters";

/**
 * PE-3386 AC2: signed and locked encounters are those with status finished.
 */
export function isEncounterSignedAndLockedForBilling(
  encounterStatus: StatusType | string | undefined,
): boolean {
  return encounterStatus === Status.Finished;
}

/**
 * Save Billing Info is only available after the encounter is signed and locked.
 */
export function canSaveEncounterBillingInfo(
  encounterStatus: StatusType | string | undefined,
): boolean {
  return isEncounterSignedAndLockedForBilling(encounterStatus);
}

/**
 * Send to Services requires signed and locked plus a resolved payment method.
 */
export function canSendEncounterBillingToServices(params: {
  encounterStatus: StatusType | string | undefined;
  isPaymentMethodLoading: boolean;
  isPaymentMethodUndetermined: boolean;
}): boolean {
  const { encounterStatus, isPaymentMethodLoading, isPaymentMethodUndetermined } = params;
  return (
    isEncounterSignedAndLockedForBilling(encounterStatus) &&
    !isPaymentMethodLoading &&
    !isPaymentMethodUndetermined
  );
}
